module.exports = __webpack_public_path__ + "static/img/G6_V1.d062c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G6_V1.png
// module id = i06S
// module chunks = 1